const PARTNER_FLOW_SESSION_KEY = 'isPartnerFlow';

/**
 * True when the current URL includes the encrypted partner deeplink query param.
 */
export const hasPartnerUrlParam = () => {
    if (typeof window === 'undefined') return false;
    return new URLSearchParams(window.location.search).has('partner');
};

/**
 * Marks the current session as a partner deeplink flow (survives in-app navigation).
 */
export const activatePartnerFlow = () => {
    if (typeof window === 'undefined') return;
    sessionStorage.setItem(PARTNER_FLOW_SESSION_KEY, 'true');
};

/**
 * True while the customer is in a partner deeplink flow for this session.
 */
export const isPartnerFlowActive = () => {
    if (typeof window === 'undefined') return false;
    if (hasPartnerUrlParam()) return true;
    return sessionStorage.getItem(PARTNER_FLOW_SESSION_KEY) === 'true';
};
